export const NAMED_ROUTES = {
  home: 'RouteHome',
  terceiros: {
    listagem: {
      inicio: 'RotaTerceiros',
      cadastro: 'RotaTerceirosCadastro',
      editar: 'RotaTerceirosEditar',
    },
    folhaPagamento: {
      inicio: 'RotaTerceirosFolhaPagamento',
      empregadoDetalhes: 'RotaTerceirosFolhaPagamentoEmpregadoDetalhes',
    },
    encargos: {
      inicio: 'RotaTerceirosEncargos',
      codigoRecolhimento: 'RotaTerceirosEncargosCodigoRecolhimento',
    },
    certidoes: {
      cadastro: 'RotaTerceirosCertidoesCadastro',
      monitoramento: 'RotaTerceirosCertidoesMonitoramento',
      historico: 'RotaTerceirosCertidoesHistorico',
    },
    solicitacoes: {
      inicio: 'RotaTerceirosSolicitacoes',
      analiseDocumento: 'RotaTerceirosSolicitacoesAnaliseDocumento',
      analiseDocumentoPorTipo: 'RotaTerceirosSolicitacoesAnaliseDocumentoPorTipo',
      analiseDocumentoPorTipoTrabalhador: 'RotaTerceirosSolicitacoesAnaliseDocumentoPorTipoTrabalhador',
    },
    trabalhoAnalogo: {
      inicio: 'RotaTerceirosTrabalhoAnalogo',
      empregadores: 'RotaTerceirosTrabalhoAnalogoEmpregadores',
    },
    trabalhadorAlocado: {
      inicio: 'RotaTerceirosTrabalhadorAlocado',
      details: 'RotaTerceirosTrabalhadorAlocadoDetails',
    },
    documentos: {
      monitoramentoDeDocumentos: 'PaginaTerceirosMonitoramentoDocumentos',
      controleValidade: 'PaginaTerceirosControleValidade',
      tiposDocumentos: 'PaginaTerceirosTipoDocumentos',
      linhaDeServico: 'PaginaTerceirosLinhasDeServico',
      checklist: 'PaginaTerceirosTipoDocumentosChecklist',
    },
    envioDocumentos: {
      inicio: 'RotaTerceirosEnvioDocumentos',
      detalhes: 'RotaTerceirosEnvioDocumentosDetalhes',
      trabalhadores: 'RotaTerceirosEnvioDocumentosTrabalhadores',
    },
  },
};
